 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"EditAcademicProject":"EditAcademicProject","SellPointAndMaterials":"SellPointAndMaterials","ManagePage":"ManagePage","BusinessManage":"BusinessManage","CarouselConfigure":"CarouselConfigure","DeviceAuth":"DeviceAuth","DistributorCustomerManage":"DistributorCustomerManage","EditCustomerManage":"EditCustomerManage","GeneralSurveyData":"GeneralSurveyData","OrderAudit":"OrderAudit","AcademicProject":"AcademicProject","AccountManage":"AccountManage","AppStarUpConfigure":"AppStarUpConfigure","DownloadCenter":"DownloadCenter","GeneralSurveyApply":"GeneralSurveyApply","PlatformNotice":"PlatformNotice","SalesmanAccountManage":"SalesmanAccountManage","SalesmanAndCustomerRelation":"SalesmanAndCustomerRelation","SalesmanOrderSummary":"SalesmanOrderSummary","SalesmanPoints":"SalesmanPoints","SalesmanRegisterApplyQuery":"SalesmanRegisterApplyQuery","SellPointAudit":"SellPointAudit","TeamOrder":"TeamOrder","TeamOrderSummary":"TeamOrderSummary","TrainingMaterialsAudit":"TrainingMaterialsAudit","WechatReport":"WechatReport","AccountSafe":"AccountSafe","Login":"Login","RoleManage":"RoleManage","BatchAddSellPointAndMaterials":"BatchAddSellPointAndMaterials","AddPlatformNoticeModal":"AddPlatformNoticeModal"}[chunkId]||chunkId) + "." + {"chunk-46ab5068":"234622f7","chunk-42b1efdc":"11ce98c3","chunk-0d71dc46":"b4cf9597","chunk-c0f59208":"1ea54aba","chunk-8053b134":"226d9cdf","chunk-f1a7b276":"e673b67a","chunk-5365841a":"2de9dcc4","chunk-6975bab5":"a25d2b30","chunk-a0462390":"db037ece","chunk-4b68ae35":"ff29e0fd","chunk-bc2fac6e":"e7aef215","chunk-1a2acc77":"630b3f65","chunk-89493ad4":"dce79e48","EditAcademicProject":"4f110231","SellPointAndMaterials":"fa333dfd","chunk-60b3f6fc":"c15f374c","chunk-9f01b524":"ccbd826d","chunk-b73d8be6":"99e4c17e","chunk-e1a1aaee":"2778fba4","ManagePage":"52a209c4","chunk-ecc1a758":"5d71ea79","chunk-0376c7c8":"fac043df","chunk-0e4dbe4d":"3de55a17","chunk-1ca95e24":"87d8543a","chunk-6b5ef664":"99d9cdcc","chunk-6a829026":"28f0fd50","chunk-4ff49913":"aae628bd","chunk-22aee20a":"a6de8f97","chunk-51ad71e8":"8223c682","chunk-c772184c":"02810142","BusinessManage":"1b13e412","CarouselConfigure":"d09de4ac","DeviceAuth":"aa37bc21","DistributorCustomerManage":"3008cb98","EditCustomerManage":"7f36d0df","GeneralSurveyData":"d4691b95","OrderAudit":"b4c687d4","chunk-1d9110ee":"60842d91","chunk-415e152e":"d09c3327","chunk-792f597a":"680156c6","AcademicProject":"76899a6f","AccountManage":"b967f31b","AppStarUpConfigure":"061a84e9","DownloadCenter":"8ff1583c","GeneralSurveyApply":"cf2fa66a","PlatformNotice":"f375ca99","SalesmanAccountManage":"0615f19a","SalesmanAndCustomerRelation":"bab213e4","SalesmanOrderSummary":"ea4d4e6a","SalesmanPoints":"0236556c","SalesmanRegisterApplyQuery":"7bb70a77","SellPointAudit":"6f056582","TeamOrder":"798e1a89","TeamOrderSummary":"0788f265","TrainingMaterialsAudit":"bb56abc8","WechatReport":"a39e7373","chunk-171f9187":"b71ac3bc","chunk-3d89779a":"b86c474f","chunk-4d44dd6c":"1f134acb","chunk-528daf14":"a6ca6780","chunk-56e5de60":"abc94226","chunk-5c138666":"af693cdd","chunk-5f47d76d":"cd20a9a2","chunk-5f4be122":"3d376cb8","chunk-7b0ab376":"ff0bd789","chunk-7b96d492":"95859baa","chunk-924f891e":"54d878cf","chunk-99b113d0":"d72e370d","chunk-9ca11692":"6cc18937","chunk-b9a9ecf6":"fe8082d0","chunk-de40083e":"e1ee33ec","chunk-34d46e94":"f011da3e","chunk-71e5e86b":"a301fab3","chunk-f4bd829c":"a2c9c618","chunk-d1f1cd50":"4b8366b9","chunk-d4b6c97c":"defed01d","chunk-9180b1d4":"d26705fd","AccountSafe":"c98a1dd7","Login":"b2f6620f","RoleManage":"a993340c","chunk-ecc52c9a":"7d5fc4eb","BatchAddSellPointAndMaterials":"494eded6","chunk-e0a8cc12":"a5bca2a1","chunk-273eecb5":"419cfee7","chunk-52e7968e":"522aed8d","AddPlatformNoticeModal":"634233b4","chunk-a09a0322":"162b5315"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-46ab5068":1,"chunk-42b1efdc":1,"chunk-0d71dc46":1,"chunk-c0f59208":1,"chunk-8053b134":1,"chunk-5365841a":1,"chunk-6975bab5":1,"chunk-a0462390":1,"chunk-4b68ae35":1,"chunk-bc2fac6e":1,"chunk-1a2acc77":1,"chunk-89493ad4":1,"EditAcademicProject":1,"SellPointAndMaterials":1,"chunk-60b3f6fc":1,"chunk-b73d8be6":1,"chunk-e1a1aaee":1,"ManagePage":1,"chunk-ecc1a758":1,"chunk-0376c7c8":1,"chunk-0e4dbe4d":1,"chunk-1ca95e24":1,"chunk-6b5ef664":1,"chunk-6a829026":1,"chunk-4ff49913":1,"chunk-22aee20a":1,"chunk-51ad71e8":1,"chunk-c772184c":1,"BusinessManage":1,"CarouselConfigure":1,"DeviceAuth":1,"DistributorCustomerManage":1,"EditCustomerManage":1,"GeneralSurveyData":1,"OrderAudit":1,"chunk-1d9110ee":1,"chunk-792f597a":1,"AcademicProject":1,"AccountManage":1,"AppStarUpConfigure":1,"DownloadCenter":1,"GeneralSurveyApply":1,"PlatformNotice":1,"SalesmanAccountManage":1,"SalesmanAndCustomerRelation":1,"SalesmanOrderSummary":1,"SalesmanPoints":1,"SalesmanRegisterApplyQuery":1,"SellPointAudit":1,"TeamOrder":1,"TeamOrderSummary":1,"TrainingMaterialsAudit":1,"WechatReport":1,"chunk-171f9187":1,"chunk-3d89779a":1,"chunk-4d44dd6c":1,"chunk-528daf14":1,"chunk-56e5de60":1,"chunk-5c138666":1,"chunk-5f47d76d":1,"chunk-5f4be122":1,"chunk-7b0ab376":1,"chunk-7b96d492":1,"chunk-924f891e":1,"chunk-99b113d0":1,"chunk-9ca11692":1,"chunk-b9a9ecf6":1,"chunk-de40083e":1,"chunk-34d46e94":1,"chunk-71e5e86b":1,"chunk-f4bd829c":1,"chunk-d1f1cd50":1,"chunk-d4b6c97c":1,"chunk-9180b1d4":1,"Login":1,"RoleManage":1,"chunk-ecc52c9a":1,"BatchAddSellPointAndMaterials":1,"chunk-e0a8cc12":1,"chunk-273eecb5":1,"chunk-52e7968e":1,"AddPlatformNoticeModal":1,"chunk-a09a0322":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"EditAcademicProject":"EditAcademicProject","SellPointAndMaterials":"SellPointAndMaterials","ManagePage":"ManagePage","BusinessManage":"BusinessManage","CarouselConfigure":"CarouselConfigure","DeviceAuth":"DeviceAuth","DistributorCustomerManage":"DistributorCustomerManage","EditCustomerManage":"EditCustomerManage","GeneralSurveyData":"GeneralSurveyData","OrderAudit":"OrderAudit","AcademicProject":"AcademicProject","AccountManage":"AccountManage","AppStarUpConfigure":"AppStarUpConfigure","DownloadCenter":"DownloadCenter","GeneralSurveyApply":"GeneralSurveyApply","PlatformNotice":"PlatformNotice","SalesmanAccountManage":"SalesmanAccountManage","SalesmanAndCustomerRelation":"SalesmanAndCustomerRelation","SalesmanOrderSummary":"SalesmanOrderSummary","SalesmanPoints":"SalesmanPoints","SalesmanRegisterApplyQuery":"SalesmanRegisterApplyQuery","SellPointAudit":"SellPointAudit","TeamOrder":"TeamOrder","TeamOrderSummary":"TeamOrderSummary","TrainingMaterialsAudit":"TrainingMaterialsAudit","WechatReport":"WechatReport","AccountSafe":"AccountSafe","Login":"Login","RoleManage":"RoleManage","BatchAddSellPointAndMaterials":"BatchAddSellPointAndMaterials","AddPlatformNoticeModal":"AddPlatformNoticeModal"}[chunkId]||chunkId) + "." + {"chunk-46ab5068":"7767b585","chunk-42b1efdc":"add616f2","chunk-0d71dc46":"ac11b77e","chunk-c0f59208":"28b0f014","chunk-8053b134":"59a93596","chunk-f1a7b276":"31d6cfe0","chunk-5365841a":"bc08d415","chunk-6975bab5":"cd1a4b6e","chunk-a0462390":"5d8e9a41","chunk-4b68ae35":"c7b0e4d8","chunk-bc2fac6e":"3f07ea70","chunk-1a2acc77":"d9e04240","chunk-89493ad4":"87065010","EditAcademicProject":"ab7fb10f","SellPointAndMaterials":"1d6b13c6","chunk-60b3f6fc":"09c1b97f","chunk-9f01b524":"31d6cfe0","chunk-b73d8be6":"510a5af6","chunk-e1a1aaee":"47b82587","ManagePage":"91df809b","chunk-ecc1a758":"0426d3d9","chunk-0376c7c8":"4434d21b","chunk-0e4dbe4d":"832c0e52","chunk-1ca95e24":"c05e932b","chunk-6b5ef664":"6bb24526","chunk-6a829026":"c14cffad","chunk-4ff49913":"42a59b68","chunk-22aee20a":"a2cf0b8b","chunk-51ad71e8":"0b7f4c13","chunk-c772184c":"745bd6c5","BusinessManage":"4edfab6e","CarouselConfigure":"0e5324d0","DeviceAuth":"77c1e955","DistributorCustomerManage":"5a5b7349","EditCustomerManage":"31a95cd3","GeneralSurveyData":"69646339","OrderAudit":"12892146","chunk-1d9110ee":"bc08d415","chunk-415e152e":"31d6cfe0","chunk-792f597a":"06d3d49f","AcademicProject":"d5ef2985","AccountManage":"25c6e8d6","AppStarUpConfigure":"bab95f5b","DownloadCenter":"e7adb522","GeneralSurveyApply":"2434004c","PlatformNotice":"21289cc2","SalesmanAccountManage":"5ab2b785","SalesmanAndCustomerRelation":"f68fdd83","SalesmanOrderSummary":"81eada2a","SalesmanPoints":"55f66226","SalesmanRegisterApplyQuery":"81eada2a","SellPointAudit":"d3468e3d","TeamOrder":"584db1c4","TeamOrderSummary":"81eada2a","TrainingMaterialsAudit":"935295d5","WechatReport":"f3ac3776","chunk-171f9187":"5c0e7fec","chunk-3d89779a":"bbf37d93","chunk-4d44dd6c":"c4769d5d","chunk-528daf14":"69293526","chunk-56e5de60":"85fefe93","chunk-5c138666":"abac7376","chunk-5f47d76d":"43e549f2","chunk-5f4be122":"1514b17e","chunk-7b0ab376":"63fae6b1","chunk-7b96d492":"8d7dcf7e","chunk-924f891e":"faba4339","chunk-99b113d0":"6841409b","chunk-9ca11692":"73a81810","chunk-b9a9ecf6":"3160bcf5","chunk-de40083e":"fb6879cb","chunk-34d46e94":"43430f49","chunk-71e5e86b":"558061e9","chunk-f4bd829c":"832c0e52","chunk-d1f1cd50":"44c765fd","chunk-d4b6c97c":"6f53c4a8","chunk-9180b1d4":"7d4f6f83","AccountSafe":"31d6cfe0","Login":"7bac9f96","RoleManage":"e60bfe57","chunk-ecc52c9a":"b3ddbb06","BatchAddSellPointAndMaterials":"928ee8c3","chunk-e0a8cc12":"5886fb0d","chunk-273eecb5":"46c16e7b","chunk-52e7968e":"ccb8d5eb","AddPlatformNoticeModal":"7abd3e9a","chunk-a09a0322":"e29a6794"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sys/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
